/* eslint-disable */
import 'jcarousel';
import 'jquery.cookie';
import ls from 'local-storage';
import { TrackJS } from 'trackjs';
import getStore from '@ve/services/getStore/getStore';
import '@/js/common/components/emptySerp/found-by-another-date.css';
import '@/js/common/components/emptySerp/view-similar-tours.css';
import '@/js/common/components/emptySerp/search__call-me-back.css';

import getHotelOfferProductsFromHotels from '@/js/common/Domain/Service/getHotelOfferProductsFromHotels';
import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';
import getTourProductFirstPaymentDefinitions
    from '@/js/common/Domain/Service/hotelSearch/services/getTourProductFirstPaymentDefinitions';

import { createApp } from '@vue/composition-api';
import {
    checkOnBlock,
    getBlockCountries,
    getAlternativeCountry,
} from '@/js/common/Domain/Service';
import ADVCakeService from '@/js/common/Domain/Service/ADVCake';
import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete';
import ProgressBar from '@/js/desktop/components/progressBar/progress-bar';
import FinishSearchWithEmptySerpService from '@/js/common/Domain/Service/FinishSearchWithEmptySerp';
import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
import toLocalStorageTourCriteriaHydrator from '@/js/common/Domain/Hydrator/toLocalStorageTourCriteria';
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';

import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import sociomanticManager from '@/js/common/Domain/Service/sociomantic';
import PriceRangeFactory from '@/js/common/Domain/Factory/PriceRange';
import WeatherWidgetView from '@/js/desktop/components/weatherWidget/weather-widget';
import ExpiredPopupView from '@/js/desktop/components/expiredPopup/ExpiredPopup';
import VisaWarningView from '@/js/desktop/components/search/visaWarning/VisaWarning';
import NoToursBannerView from '@/js/common/components/no-tours-banner/no-tours-banner';
import differencesTourCriteria from '@/js/common/Domain/Service/differencesTourCriteria';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import sendGoogleRematketingRequest from '@/js/common/Domain/Service/googleRemarketing';
import SearchRequestFactory from '@/js/common/Domain/Factory/SearchRequest';
import { DESKTOP_SEARCH_PAGE_BANNER_STEP } from '@/js/common/Constants/bannerSteps';

import HotelOffersTab from '@ve/components/hotelOffersTab/desktop/HotelOffersTab.vue';
import HotelOffersSearch from '@/js/common/Domain/Service/HotelOffersSearch';

import fromRouterHydrator from '@/js/common/components/hotelOffersSearch/router/fromRouter';
import toRouterHydrator from '@/js/common/components/hotelOffersSearch/router/toRouter';
import getTakenFiltersStructure from '@ve/pages/serp/components/previousFilterApplying/services/getTakenFiltersStructure';

import SearchPageHotelOffersList from './SearchPageHotelOffersList';
import SearchPageHotelOfferView from './SearchPageHotelOfferView';
import SearchPageHotelOffersModel from './model/SearchPageHotelOffersModel';
import postFilterAdapter from './service/postFilterAdapter';

const ADVCake = new ADVCakeService('search');

const HotelOffersSearchController = Backbone.View.extend({
    currentSearchModel: new TourCriteriaObjectValue(),
    progressBarTimer: 0,
    weatherWidget: null,
    tourCriteriaForSearchByDefaultsCriteria: null,
    view: null,
    fromRouterHydrator,
    toRouterHydrator,
    searchOptions() {
        return null;
    },
    initDataAnalyticsService() {
        this.dataLayerAnalytics = new DataLayerAnalytics({
            step: 'searchPage',
            maxStep: 1,
            bannersStep: DESKTOP_SEARCH_PAGE_BANNER_STEP,
        });
    },
    initSearchForm() {
        this.searchFormView = new SearchFormAutocompleteView();
    },
    initModels() {
        this.initSearchForm();
        this.model = this.searchFormView.model;

        this.initSearchPageView();
    },
    initSearchPageView() {
        this.view = new SearchPageHotelOffersList({
            el: '#forSearchView',
            dataLayerAnalytics: this.dataLayerAnalytics,
            searchFormViewModel: this.model,
            SearchPageHotelView: SearchPageHotelOfferView,
            SearchPageModel: SearchPageHotelOffersModel,
            withoutStatic: true,
        });
    },
    initComponents() {
        const self = this;

        this.progressBar = new ProgressBar({ el: '#searchProgressBar', parent: this.view.model });

        this.weatherWidget = new WeatherWidgetView({ el: '#weatherWidget' });

        new ExpiredPopupView({
            el: '#expiredContainer',
            searchPageViewModel: this.view.model,
            updateResultCallback() {
                self.formSubmit({ goToHotelPage: false });
            },
        });

        new VisaWarningView({
            el: '#visaWarning',
            searchPageViewModel: this.view.model,
        });

        this.noToursBanner = new NoToursBannerView({
            labels: {
                checkInDateRange: 'Дата заезда',
            },
            el: '.js-component-no-tours-banner',
            model: this.view.model,
            controllerModel: this.model,
        });

        this.initVueComponents();

        this.searchFinish = new FinishSearchWithEmptySerpService(this.searchService, this, this.searchOptions(), {
            productType: 'HotelOfferProduct',
        });
    },
    initVueComponents() {
        createApp(HotelOffersTab, {
            isActive: true,
        }).mount('.js-hotel-offers-tab');
    },
    changeFilterAsCriteriaDebounce: _.debounce(function (event, model, context) {
        this.changeFilterAsCriteria(event, model, context);
    }, 1000),
    changeFilterAsCriteria(event, model, context) {
        if (context && (context.initiator === 'view' || context.initiator === 'filtersPopover')) {
            this.formSubmit({ goToHotelPage: false, openBooking: false });
        }
    },
    getUpdateUrl() {
        const currentTourCriteria = this.model.getTourCriteria();
        const otherCriterias = this.view.getOtherCriterias();
        const paramsForRouter = this.toRouterHydrator(currentTourCriteria, otherCriterias);

        return `?${$.param(paramsForRouter)}`;
    },
    updateUrl(model, value, context, options) {
        const url = this.getUpdateUrl();
        const router = new SearchRouter().getInstance();

        router.go(url, options || {});
    },

    updateFirstPaymentDefinitions() {
        const syncHotels = this.view.model.get('syncHotels');

        if (syncHotels?.length) {
            const hotelOffers = getHotelOfferProductsFromHotels(syncHotels);
            const firstPaymentDefinitions = getTourProductFirstPaymentDefinitions(hotelOffers);
            firstPaymentDefinitionService.setData(firstPaymentDefinitions);
        }
    },

    initEvents() {
        const router = new SearchRouter().getInstance();
        const $toursList = $('.staticContainer.hotelsContainer');

        router.on('route', this.changeRouteInit.bind(this));

        this.model.get('departureCity').on('change:model', this.model.departureCityChanged.bind(this));
        this.model.get('countries').on('change:model', this.model.countriesChanged.bind(this));
        this.model.get('hotels').on('change:model', this.model.hotelsChanged.bind(this));

        this.model.get('resorts').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
        this.model.get('meals').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
        this.model.get('hotelCategories').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
        this.model.get('warranted').on('change:model', this.changeFilterAsCriteria.bind(this));

        this.view.model.on('change:syncHotels', this.updateFirstPaymentDefinitions.bind(this));
        this.view.model.on('change:sortStrategy', this.updateUrl.bind(this));
        this.view.model.get('filterCriteria').on('change', this.updateUrl.bind(this));
        this.view.model.on('change:loadingState', (model, value) => {
            if (this.searchFinish) {
                this.searchFinish.searchFinished(value);
            }
        });

        this.currentSearchModel.on('change', this.goSearch.bind(this));
        this.model.on('startSearch', this.formSubmit.bind(this));
        this.model.on('goAsyncSearch', (tourCriteria) => { this.goSearch(tourCriteria); });
        $('#startSearch, .startSearch').on('click', this.formSubmit.bind(this));
    },
    startSearchIfControlChanged: null,
    getAdditionalData() {
        return {};
    },
    startSearchForce() { // abstract
        return false;
    },
    changeRouteInit(type, url) {
        const self = this;
        const controlChanged = function () {
            self.view.model.set('beforeToursLoading', false);
            self.changeRouteInit = self.changeRoute;
            self.changeRoute(type, url, additionalData.setTourCriteria);
        };
        var additionalData = typeof window.appConfig.defaultTourCriteria !== 'undefined' ? window.appConfig.defaultTourCriteria : {};

        url = _.isArray(url) ? url[0] : url;

        additionalData = { setTourCriteria: $.extend({}, additionalData, this.getAdditionalData()) };
        this.startSearchIfControlChanged = controlChanged;

        if (type === 'search' || window.appConfig.noToursFound || this.startSearchForce()) {
            this.view.model.set('beforeToursLoading', false);
            this.view.model.set('tourCriteriaLoaded', true);
            self.changeRouteInit = self.changeRoute;
            this.changeRoute(type, url, additionalData.setTourCriteria);
        } else {
            this.model.get('countries').setNull();
            this.model.get('resorts').setNull();
            this.model.get('hotels').setNull();
            this.model.get('checkInDateRange').setNull();
            this.model.get('nightRange').setNull();
            this.model.get('touristGroup').setNull();
            this.model.get('hotelCategories').setNull();
            this.model.get('meals').setNull();
            this.model.get('priceRange').setNull();

            searchSessionService.generateNewSearchId();

            tourCriteriaService.loadTourCriteriaWithFormData(additionalData, {
                success(tourCriteria) {
                    self.model.setTourCriteria(tourCriteria);
                    self.view.model.on('change:sortStrategy change:viewMode', controlChanged);
                    self.view.model.set('tourCriteriaLoaded', true);
                    self.view.model.get('filterCriteria').on('change', controlChanged);
                    $('.showMoreBtn').one('click', controlChanged);
                    self.model.trigger('formDataLoaded');
                    self.view.model.trigger('formDataLoaded');
                },
            });
        }
    },
    storeCriteria(tourCriteria) {
        const paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(tourCriteria);

        ls.set('tourCriteria__hotelOffers', paramsForLocalStorage);
    },
    changeRoute(type, url, additionalData) {
        let setTourCriteria = {};
        const self = this;
        const loadTourCriteriaWithFormData = function (params, callback) {
            tourCriteriaService.loadTourCriteriaWithFormData(params, {
                success(tourCriteria) {
                    self.model.setTourCriteria(tourCriteria);
                    callback();
                    self.model.trigger('formDataLoaded');
                },
                error() {
                },
            });
        };

        if (type === 'search') {
            setTourCriteria = this.fromRouterHydrator(_.isArray(url) ? url[0] : url);
        } else {
            if (additionalData) {
                setTourCriteria.tourCriteria = additionalData;
            }
            tourCriteriaService.clearTourCriteriaChangedFields();
        }
        self.view.setOtherCriterias(setTourCriteria.other);
        setTourCriteria = $.extend({}, this.getAdditionalData(), setTourCriteria.tourCriteria);

        this.model.get('countries').setNull();
        this.model.get('resorts').setNull();
        this.model.get('hotels').setNull();
        this.model.get('checkInDateRange').setNull();
        this.model.get('nightRange').setNull();
        this.model.get('touristGroup').setNull();
        this.model.get('hotelCategories').setNull();
        this.model.get('meals').setNull();
        this.model.get('priceRange').setNull();

        loadTourCriteriaWithFormData({ setTourCriteria }, () => {
            const currentTourCriteria = self.model.getTourCriteria();

            self.updateUrl(null, null, null, { replace: true });

            self.storeCriteria(currentTourCriteria);
            self.currentSearchModel.set(currentTourCriteria.attributes);
            self.view.model.set('searchData', currentTourCriteria);
            self.view.scrollToTop();
            self.model.trigger('formDataLoaded');
        });
    },
    weatherUpdate(tourCriteria) {
        if (this.weatherWidget) {
            if (tourCriteria) {
                this.weatherWidget.updateData(tourCriteria);
            } else {
                this.weatherWidget.updateData(this.model.getTourCriteria());
            }
        }
    },
    weatherReset() {
        if (this.weatherWidget) {
            this.weatherWidget.updateData();
        }
    },

    formSubmit(params) {
        const store = getStore();
        store.commit('mapForFiltersSerp/setDefaultHotelsFilter');
        store.commit('previousFilterStore/setDefaultPreviousStore');
        const goToHotelPage = !(params && params.goToHotelPage === false);
        if (!(params && params.notCloseEmptySerpBanners)) {
            this.view.model.closeEmptySearchBanners();
            if (this.noToursBanner) {
                this.noToursBanner.hideBanner();
            }
        }
        if (this.model.getTourCriteria().isValid() && this.searchFormView.isValid()) {
            const self = this;
            const departureCityType = this.model.get('departureCity').get('model').get('type');
            const { priceRange } = CountriesRepository.repository.at(0).get(`${departureCityType}TourCriteria`);

            this.weatherReset();
            console.log('Submit search form');
            this.view.model.set('beforeToursLoading', false);

            this.model.get('priceRange').set('model', new PriceRangeFactory(priceRange));
            searchSessionService.changeSearchIdForNewSearch({
                oldSearchCriteria: this.view.model.get('searchData'),
                newSearchCriteria: this.model.getTourCriteria(),
            });
            if (differencesTourCriteria({
                oldSearchCriteria: this.view.model.get('searchData'),
                newSearchCriteria: this.model.getTourCriteria(),
            })) {
                this.view.model.trigger('differencesFormCriteria');
                store.commit('previousFilterStore/setSyncProducts', 0);
                store.commit('previousFilterStore/setFilterPreviousStateFilters', { ...store.state.mapForFiltersSerp });
                this.view.clearFilter({
                    currentModel: this.model, onlyPostfilters: true,
                });
            }
            const currentTourCriteria = this.model.getTourCriteria();
            const currentTourCriteriaAttributes = currentTourCriteria.attributes;
            let paramsForRouter;
            const router = new SearchRouter().getInstance();
            const forceChangeTrigger = _.isEqual(this.currentSearchModel.attributes, currentTourCriteria.attributes);
            let goToUrl;

            $.cookie('markSearchSource', true, { path: '/', domain: 'all' });

            this.storeCriteria(currentTourCriteria);

            if (goToHotelPage && currentTourCriteria.get('hotels') && currentTourCriteria.get('hotels').length === 1) {
                paramsForRouter = toRouterHotelHydrator({
                    tourCriteria: currentTourCriteria,
                    productType: 'hotelOffer',
                });
                goToUrl = `/goto/hotel/${currentTourCriteria.get('hotels').at(0).get('id')}#?${$.param(paramsForRouter)}`;
                router.go(goToUrl);
            } else {
                if (params && params.openBooking == false) {
                    self.updateUrl();
                } else {
                    self.updateUrl();
                    if (this.dataLayerAnalytics) {
                        this.dataLayerAnalytics.clickSearchButtonEvent();
                    }
                }

                currentTourCriteriaAttributes.track = 1;
                this.currentSearchModel.set(currentTourCriteriaAttributes, {
                    resetLoader: true,
                    additionalSearch: !!(params && params.additionalSearch),
                    initiator: params?.initiator || null,
                });

                //to force search with same params
                if (forceChangeTrigger) {
                    this.currentSearchModel.trigger('change', this.currentSearchModel);
                }

                this.view.model.set('subscribe', '0');

                this.view.model.set('searchData', currentTourCriteria);
                this.model.trigger('submitSearch');
            }
        }
    },
    checkFiltersAvailibility() {
        const hotels = this.view.model.get('syncHotels');
        const filteredHotels = this.view.model.get('filteredHotels');

        if (!filteredHotels.length && hotels && hotels.length) {
            this.view.clearFilter({ currentModel: this.model, onlyPostfilters: true });
        }
    },
    modifyTourCriteria(tourCriteria) {
        return tourCriteria;
    },
    analyticsCall(tourCriteria) {
        if (this.dataLayerAnalytics.sid !== searchSessionService.getSearchId()) {
            const value = {
                prop: [{
                    type: 'hotel_ids',
                    value: tourCriteria.get('hotels')?.pluck('id')?.join() || [],
                }, {
                    type: 'resorts',
                    value: tourCriteria.get('resorts')?.pluck('name')?.join() || [],
                }],
            };

            this.dataLayerAnalytics.generateEvent('checkHotelResort', value);
            this.dataLayerAnalytics.generateEvent('sid', searchSessionService.getSearchId());
            this.dataLayerAnalytics.initBasicEvents(tourCriteria);
        }
    },
    prepareSearchRequests(tourCriteria) {
        return [new SearchRequestFactory(tourCriteria)];
    },
    startSearchTracking(tourCriteria, type) {
        const timestamp = (new Date()).getTime();

        if (type === 'userSearch') {
            trackingService.trackStartSearch({
                tourCriteria,
                timestamp,
                productType: 'HotelOfferProduct',
            });
        } else {
            trackingService.trackStartEmptySearch({
                tourCriteria,
                timestamp,
                productType: 'HotelOfferProduct',
            });
        }

        mindBoxService.trackViewSerp('serp_hotel', this.model, this.view.model);
    },
    searchScrollHandler() {
        const newUrl = window.location.href;
        const isSuccessSearch = !!~newUrl?.indexOf('fromCity')
            || !!~newUrl?.indexOf('toCountry');

        if (isSuccessSearch) {
            document.removeEventListener('scroll', this.searchScrollHandler);
            return;
        }

        window.appConfig.noToursFound = false;
        window.appConfig.hideUpdatePriceBanner = true;
        this.formSubmit();
    },
    initSearchOnScroll(callback) {
        const currentUrl = window.location.href;
        const isDynamicSearch = !!~currentUrl?.indexOf('fromCity')
            || !!~currentUrl?.indexOf('toCountry');

        if (isDynamicSearch) return;

        document.addEventListener('scroll', () => {
            callback?.();
            this.searchScrollHandler();
        });
    },
    manualyChangeCountry(tourCriteria, blockCountries) {
        const countryModel = tourCriteria.get('countries').at(0);
        const alternativeCountry = getAlternativeCountry(blockCountries, countryModel);
        const newCountryModel = new Backbone.Collection([alternativeCountry]);

        this.view.model.get('lastBlockedTourCriteriaByCountry')?.push(tourCriteria.clone());
        tourCriteria.set('countries', newCountryModel);
        this.model.setTourCriteria(tourCriteria); // will start new goSearch by events
        this.model.trigger('startSearch', { initiator: 'manual' });
    },
    async goSearch(tourCriteria, params) {
        if (!this.goSearch.counter) this.goSearch.counter = 1;
        else this.goSearch.counter += 1;

        let searchServiceParamsCollection;
        const self = this;
        let dynx;
        self.view.model.set('covidBanner', false);
        self.view.model.off('change:sortStrategy change:viewMode', this.startSearchIfControlChanged);
        self.view.model.get('filterCriteria').off('change', this.startSearchIfControlChanged);

        try {
            const blockCountries = await getBlockCountries();
            const lastTourCriteria = this.view.model.get('lastBlockedTourCriteriaByCountry')?.slice(0).pop();
            const isLastCountryWasBlocked = lastTourCriteria && checkOnBlock(lastTourCriteria, blockCountries);
            const isCurrentCountryIsBlocked = checkOnBlock(tourCriteria, blockCountries);

            if (isLastCountryWasBlocked) {
                this.view.model.set('countryIsClose', true);
            } else {
                this.view.model.set('countryIsClose', false);
            }

            if (isCurrentCountryIsBlocked) {
                this.manualyChangeCountry(tourCriteria, blockCountries);

                return;
            }

            if (params?.initiator === 'manual') {
                this.view.model.get('lastBlockedTourCriteriaByCountry')?.pop();
            }
        } catch (error) {
            TrackJS.track(error);
        }

        if (tourCriteria.isValid() && tourCriteria.get('countries') && tourCriteria.get('countries').length) {
            ADVCake.updateSearchData(tourCriteria);
            dynx = {
                dynx_pagetype: 'searchresults',
                dynx_itemid2: typeof remarketingCountries !== 'undefined' ? remarketingCountries[tourCriteria.get('countries').at(0).get('id')] : '',
            };

            sendGoogleRematketingRequest(dynx);

            this.progressBar.reset();
            this.progressBar.moveToValue(50);

            tourCriteria = this.modifyTourCriteria(tourCriteria);
            self.view.model.trigger('change:syncHotels');

            searchServiceParamsCollection = this.prepareSearchRequests(tourCriteria);

            self.view.model.set('loadingState', 'loading');
            self.view.model.set('loadingInProgress', true);

            const finished = {
                sync: false,
                async: false,
            };

            clearInterval(this.progressBarTimer);
            this.progressBarTimer = setInterval(() => {
                if (finished.sync) {
                    const asyncStatus = self.searchService.getAsyncStatus();
                    const { jobsCount } = asyncStatus;
                    const jobsSuccess = asyncStatus.jobsCount;
                    let jobPercents = 50;
                    if (jobsCount && jobsSuccess !== jobsCount) {
                        jobPercents += 50 / jobsCount * (jobsSuccess + 1);
                    } else {
                        jobPercents = 100;
                    }
                    if (jobPercents === 100) {
                        clearInterval(self.progressBarTimer);
                    }
                    self.progressBar.moveToValue(jobPercents);
                }
            }, 1000);

            this.startSearchTracking(tourCriteria, (params && params.additionalSearch) ? 'emptySearch' : 'userSearch');

            self.searchService.getOffersData({
                searchUuid: trackingService.getSearchUuid(),
                clientUuid: trackingService.getClientUuid(),
                customerUuid: trackingService.getCustomerUuid(),
                originalSearchUuid: trackingService.originalSearchUuid,
                requests: searchServiceParamsCollection,
                callback: {
                    sync: (hotels, tourProducts) => {
                        this.initHotelOptions(hotels.models);
                        if (hotels.length > 0) {
                            if (!finished.async) {
                                self.view.model.set('loadingState', 'asyncLoading');
                            }
                            self.view.model.set('asyncTourProducts', null);
                            self.view.model.set('asyncHotels', null);
                            self.view.model.set('similarHotels', null);
                            self.view.collection.reset();
                            self.view.model.set('pageNumber', 1, { silent: true });
                            self.view.model.set('syncHotels', hotels);
                            self.view.model.set('loadingInProgress', false);
                            self.view.model.trigger('change:syncHotels');
                            self.view.model.updateRenderedCollection();
                        } else {
                            self.view.model.set('syncHotels', hotels, { silent: true });
                        }

                        self.view.model.set('syncTourProducts', tourProducts, { silent: true });
                        self.view.model.trigger('change:syncTourProducts', self.view.model, tourProducts);

                        self.view.model.set('firstHotelsPrices', hotels.reduce((memo, hotel) => (memo[hotel.get('id')] = hotel.get('minPrice')) && memo, {}));
                        finished.sync = true;
                        if (finished.async) {
                            if (self.view.model.get('loadingInProgress')) {
                                self.view.collection.reset();
                                self.view.model.set('pageNumber', 1, { silent: true });
                                if (hotels.length === 0) {
                                    self.view.model.trigger('change:syncHotels');
                                }
                            }
                            self.view.model.updateRenderedCollection();
                            self.view.model.set('loadingInProgress', false);
                            clearInterval(self.progressBarTimer);
                            self.progressBar.complete();
                            self.view.model.set('loadingState', 'finished');
                        }
                        console.log('changed', 'syncHotels', 'syncTourProducts');
                    },
                    middleRequest: (updatedHotels, newHotelsLength) => {
                        const tourProducts = self.view.model.get('syncTourProducts');
                        self.view.model.trigger('change:syncTourProducts', self.view.model, tourProducts);
                        this.initHotelOptions(updatedHotels);

                        if (newHotelsLength) {
                            self.view.model.trigger('change:syncHotels');
                        }

                        if (updatedHotels.length) {
                            self.view.model.set('loadingInProgress', false);
                            self.view.model.updateRenderedCollection();
                            if (finished.async) {
                                clearInterval(self.progressBarTimer);
                                self.progressBar.complete();
                                self.view.model.set('loadingState', 'finished');
                            } else {
                                self.view.model.set('loadingState', 'asyncLoading');
                            }
                        }
                    },
                    async: (updatedHotels, newHotelsLength, options) => {
                        const hotels = self.view.model.get('syncHotels');
                        const firstHotelsPrices = self.view.model.get('firstHotelsPrices');
                        const tourProducts = self.view.model.get('syncTourProducts');
                        self.view.model.trigger('change:syncTourProducts', self.view.model, tourProducts);

                        this.initHotelOptions(updatedHotels);

                        if (newHotelsLength) {
                            self.view.model.trigger('change:syncHotels');
                        }

                        if (updatedHotels.length) {
                            self.view.model.updateRenderedCollection();
                        }

                        if (!(params && params.additionalSearch)) {
                            trackingService.trackHotelOffersSearch({
                                productType: 'HotelOfferProduct',
                                tourCriteria,
                                foundHotels: hotels || {},
                                firstHotelsPrices,
                                timestamp: options.startSearchTime,
                                firstCacheTime: options.firstCacheTime,
                                searchFinishedTime: options.searchFinishedTime,
                                scannedTours: options.scannedTours,
                                error: options.error,
                            });
                        }

                        if (self.dataLayerAnalytics && self.dataLayerAnalytics.searchCountEvent) {
                            self.dataLayerAnalytics.searchCountEvent((hotels && hotels.length) ? hotels.length : 0);
                            self.dataLayerAnalytics.generateTop20Event(hotels?.length ? self.view.model.get('filteredHotels') : []);
                        }

                        if (hotels && hotels.length === 0 && !self.view.model.get('similarHotels')) {
                            gaAsync(() => {
                                ga('send', 'event', 'SearchResults', 'No_Results', document.location.pathname + document.location.hash, { nonInteraction: 1 });
                            });
                        } else {
                            sociomanticManager.notifyCategory(tourCriteria);
                            if (hotels) {
                                gaAsync(() => {
                                    ga('send', 'event', 'SearchResults', hotels.length, document.location.pathname + document.location.hash, { nonInteraction: 1 });
                                });
                            }
                        }

                        finished.async = true;

                        if (finished.sync) {
                            if (self.view.model.get('loadingInProgress')) {
                                self.view.collection.reset();
                                self.view.model.set('pageNumber', 1, { silent: true });
                                if (updatedHotels.length === 0) {
                                    self.view.model.trigger('change:syncHotels');
                                }
                            }
                            self.view.model.updateRenderedCollection();
                            self.view.model.set('loadingInProgress', false);
                            clearInterval(self.progressBarTimer);
                            self.progressBar.complete();
                            self.view.model.set('loadingState', 'finished');
                        }
                        console.log('changed', 'asyncHotels', 'asyncTourProducts', 'loadingState');
                    },

                },
                urls: this.searchOptions(),
            });
            this.weatherUpdate();

            this.analyticsCall(tourCriteria);
        }
    },
    initHotelOptions(hotels) {
        _.each(hotels, (hotel) => {
            hotel.initHotelOffersOptions();
        });
    },
    initSearchService() {
        this.searchService = new HotelOffersSearch();
    },
    initPostFilters() {
        const postFilters = window?.appConfig?.defaultTourCriteria?.postFilters;
        if (postFilters && !document.location.hash) {
            const filterCriteria = postFilterAdapter(postFilters);
            this.view.model.get('filterCriteria').set(filterCriteria);
        }
    },
    initialize() {
        this.initDataAnalyticsService();
        this.initSearchService();
        this.initModels();
        this.initComponents();
        this.initPostFilters();
        this.initEvents();
    },
});

export default HotelOffersSearchController;
